export const colorMapper = (colorChoice: number): string => {
    const colorChoices: Record<number, string> = {
        0: "#f8f9fa", // Off White
        1: "#ffcdd2", // Pastel Red
        2: "#ffe0b2", // Pastel Orange
        3: "#dcedc8", // Pastel Light Green
        4: "#bbdefb", // Pastel Blue
        5: "#e1bee7", // Pastel Purple
        6: "#f8bbd9", // Pastel Pink
        7: "#d7ccc8", // Pastel Brown
        8: "#fff9c4", // Pastel Yellow
        9: "#b2dfdb", // Pastel Sea Green
        10: "#c5e1f8", // Pastel Light Blue
    };
    return colorChoices[colorChoice] || "#f8f9fa";
};

// Improved contrast function that uses black or white text for better readability
export const getContrastTextColor = (backgroundColor: string): string => {
    // Convert hex to RGB
    const r = parseInt(backgroundColor.slice(1, 3), 16);
    const g = parseInt(backgroundColor.slice(3, 5), 16);
    const b = parseInt(backgroundColor.slice(5, 7), 16);

    // Calculate relative luminance using the W3C formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black text for light backgrounds, white text for dark backgrounds
    return luminance > 0.5 ? "#000000" : "#ffffff";
};

